import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

const json = () => authHeaders({ "Content-Type": "application/json" });

const getAll = async () => {
  const res = await axios.get(`${API_URL}couriers`, { headers: authHeaders() });
  return res.data;
};

const create = async (data) => {
  const res = await axios.post(`${API_URL}couriers/create`, data, { headers: json() });
  return res.data;
};

const remove = async (id) => {
  const res = await axios.post(`${API_URL}couriers/delete`, { id }, { headers: json() });
  return res.data;
};

export default { getAll, create, remove };